<template>
  <div>
    <div class="products">
      <div class="container">
       vbvbvb {{products}}bvbvbv
      </div>
    </div>
  </div>
</template>

<script>
  //import ProductItem from './ProductItem.vue'
  export default {
    name: 'product-list',
    created () {
      if (this.products.length === 0) {
        this.$store.dispatch('allProducts')
      }
    },
    computed: {
      products () {
        return this.$store.getters.allProducts
      }
    },
    data () {
      return {

      }
    },
    // components: {
    //   'product-item': ProductItem
    // }
  }
</script>


// WEBPACK FOOTER //
// ProductList.vue?356c073a